// import LayoutNews from "@/layouts/LayoutNews";

export default {
  path: "/hangye",
  name: "hangye",
  meta: {
    title: "行业概况",
    icon: require('@/assets/images/icons/hangye.png')
  },
  component: () => import("@/views/hangye/index.vue"),
  // component: LayoutNews,
  // redirect: "/hangye/gonglu",
  children: [
    // {
    //   path: "gonglu",
    //   name: "gonglu",
    //   meta: {
    //     title: "公路概况",
    // icon: require('@/assets/images/icons/hangye.png')
    //   },
    //   component: () => import("@/views/hangye/gonglu.vue"),
    // },
    // {
    //   path: "shuilu",
    //   name: "shuilu",
    //   meta: {
    //     title: "水路概况",
    // icon: require('@/assets/images/icons/hangye.png')
    //   },
    //   component: () => import("@/views/hangye/shuilu.vue"),
    // },
  ],
};